import IWalletDto from "../../interfaces/wallet/IWalletDto";
import { cryptoPortfolioService } from "../httpService/cryptoPorfolio.service";

export async function tryGetAllWalletList(isActive?: boolean) {
    if (isActive != null) {
        return await cryptoPortfolioService.get<IWalletDto[]>(`/wallet/getallwalletlist?isActive=${isActive}`);
    }

    return await cryptoPortfolioService.get<IWalletDto[]>(`/wallet/getallwalletlist`);
}

export async function tryGetWalletById(walletId: string) {
    return await cryptoPortfolioService.get<IWalletDto>(`/wallet/getbyid/${walletId}`)
}

export async function tryGetAllBalancedWallet() {
    return await cryptoPortfolioService.get<IWalletDto[]>('/wallet/getallbalanced');
}

export async function tryCreateNewWallet(walletDto: IWalletDto) {
    return await cryptoPortfolioService.post('/wallet/create', walletDto);
}

export async function tryUpdateWallet(walletDto: IWalletDto) {
    return await cryptoPortfolioService.put('/wallet/update', walletDto);
}

export async function tryRemoveWalletById(walletId: string) {
    return await cryptoPortfolioService.delete(`/wallet/delete/${walletId}`);
}

export async function tryToogleWalletIsActive(walletId: string) {
    return await cryptoPortfolioService.patch(`/wallet/toogleisactive/${walletId}`);
}

export async function tryToogleWalletIsBalanced(walletId: string) {
    return await cryptoPortfolioService.patch(`/wallet/toogleisbalancedwallet/${walletId}`);
}